import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import routes from '../../routes';
import { templateSelectors } from '../../store/modules/template';

const { Router } = routes;

const useCheckPageNumber = () => {
  const pagesCount = useSelector(templateSelectors.selectTemplatesPagesCount);
  const currentPage = useSelector(templateSelectors.selectTemplatesCurrentPage);

  useEffect(() => {
    const canRedirectTo404 = pagesCount && currentPage > pagesCount;

    canRedirectTo404 && Router.pushRoute('404', {}, { shallow: true });
  }, [pagesCount, currentPage]);

  const isError = pagesCount && currentPage > pagesCount;

  return isError;
};

export default useCheckPageNumber;
